import { Component, OnInit, ViewChild, ElementRef, isDevMode, AfterContentInit } from '@angular/core';
import * as jspreadsheet from "jspreadsheet";
import * as jss_statusbar from "@jspreadsheet/statusbar";
import * as jss_formula from "@jspreadsheet/editor";
import * as render from '@jspreadsheet/render';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import * as LZString from 'lz-string';
import Swal from 'sweetalert2';
import { DashboardService2Service } from 'src/app/services/dashboard-service2.service';
import '../../../type.ts';

@Component({
  selector: 'app-dashboard-dev',
  templateUrl: './dashboard-dev.component.html',
  styleUrls: ['./dashboard-dev.component.css']
})
export class DashboardDevComponent implements OnInit, AfterContentInit {
  @ViewChild("spreadsheet") spreadsheet!: ElementRef;
  @BlockUI('loading') blockUI!: NgBlockUI;

  isOK = false;

  id!: number;

  dashData: Array<any> = [];
  template = [];
  SS: any;

  height = 0;

  isMoving = false;

  configuracoes: any = null;

  noPrint = [
    'F00 - LOG',
    'F01 - Inicial',
    'F02 - DARFs',
    'F03A - DCTF - PC CUMULATIVO',
    'F03B - DCTF - PC NAO CUMULATIVO',
    'F04A - DCTF - IRCS PRESUMIDO',
    'F04B - DCTF - IRCS REAL TRIMEST',
    'F04C - DCTF - IRCS REAL ANUAL',
    'F05A - SPED CT - PC CUMULATIVO',
    'F05B - SPED CT -  PC N CUMULAT',
    'F06 - SPED CT - INSUMOS',
    'F07 - SPED CT - CST',
    'F08 - ECF - IRPJ',
    'F09 - ECF - CSLL',
    'F10 - COMP FONTES PAGADORAS',
    'F11 - COMPARATIVO DE RECEITAS',
    'F12A - DARFxDCTFxSPED PC CUMULA',
    'F12B - DARFxDCTFxSPED PC NAOCUM',
    'F13A - DARFxDCTFxECF IRCS PRESU',
    'F13B - DARFxDCTFxECF IRCS R TRI',
    'F13C - DARFxDCTFxECF IRCS RA',
    'F14a - APURAÇÕES DCTF X SPEDCT',
    'F14b - APURAÇÕES DCTF X SPEDECF'
  ];

  constructor(public userService: UserService, private route: ActivatedRoute, private router: Router, private dashService: DashboardService2Service) { }

  ngOnInit(): void {
    this.height = window.innerHeight - 53
    this.id = parseInt(this.route.snapshot.paramMap.get('id')!);

    if (this.userService.checarPermissao('2')[0]) {
      this.isOK = true;
    } else {
      return;
    }
  }

  async ngAfterContentInit() {
    this.blockUI.start('Buscando dados...');
    try {
      const res: any = await this.fetchSheet(this.id, '[]');
      if (res[0]['nomes'] === null) {
        this.router.navigate(['/home']);
      }
      if (this.SS === undefined) {
        this.template = res[0]['template']
        this.dashData = [];
        this.dashData.push(JSON.parse(LZString.decompressFromBase64(res[0]['data'])));
        let tmp = JSON.parse(res[0]['nomes']).reverse();
        tmp.shift()
        for (const element of tmp) {
          this.dashData.push(
            {
              'worksheetName': element
            }
          )
        }
        this.initXLSX();
      }
    } catch (rejectedValue) {
      if (isDevMode()) {
        throw (rejectedValue);
      }
    }
    this.blockUI.stop()
    if (this.dashData[0].data[0][0] == 0) {
      this.scoreCard();
    }
  }

  donut(color, pct) {
    let canvas = document.createElement('canvas');
    canvas.width = 300;
    canvas.height = 300;
    let ctx = canvas.getContext("2d");
    let values = [pct];
    let colors = [color]

    const arcwidth = 30;
    const cx = 150;
    const cy = 150;
    const radius = 125
    if (ctx) {
      let tot = 0;
      let accum = 0;
      let PI = Math.PI;
      let PI2 = PI * 2;
      let offset = -PI / 2;
      ctx.lineWidth = arcwidth;
      for (let i = 0; i < values.length; i++) { tot += values[i]; }
      for (let i = 0; i < values.length; i++) {
        ctx.beginPath();
        ctx.arc(cx, cy, radius,
          offset + PI2 * (accum / tot),
          offset + PI2 * ((accum + values[i]) / tot)
        );
        ctx.strokeStyle = colors[i];
        ctx.stroke();
        accum += values[i];
      }
      ctx.beginPath();
      ctx.font = 'bold 90px calibri';
      if (values[0] == 100) {
        ctx.fillText(values[0] + '%', 50, 180);
      } else {
        ctx.fillText(values[0] + '%', 70, 180);
      }
      return canvas.toDataURL();
    }
    return ''
  }

  async scoreCard() {
    this.blockUI.start('Buscando dados...');
    try {
      if (this.configuracoes === null) {
        this.configuracoes = await this.fetchConfiguracoes();
      }

      let requisitos = [
        'F00 - LOG',
        'F01 - Inicial',
        'F02 - DARFs',
        'F03A - DCTF - PC CUMULATIVO',
        'F03B - DCTF - PC NAO CUMULATIVO',
        'F04A - DCTF - IRCS PRESUMIDO',
        'F04B - DCTF - IRCS REAL TRIMEST',
        'F04C - DCTF - IRCS REAL ANUAL',
        'F05A - SPED CT - PC CUMULATIVO',
        'F05B - SPED CT -  PC N CUMULAT',
        'F06 - SPED CT - INSUMOS',
        'F07 - SPED CT - CST',
        'ECF - L300'
      ]

      for (let req of requisitos) {
        if (this.dashData[this.dashData.findIndex(element => element.worksheetName === req)] !== undefined) {
          if (this.dashData[this.dashData.findIndex(element => element.worksheetName === req)]['data'] === undefined) {
            this.isMoving = true;
            await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === req), 'Buscando dados...', 1);
            this.isMoving = false;
          }
        }
      }

      this.dashData[0].data[1][3] = this.configuracoes.header;
      this.dashData[0].data[4][2] = this.dashData[2].data[13][3]
      this.dashData[0].data[5][2] = this.dashData[2].data[12][3]
      this.dashData[0].data[5][4] = 'Janeiro/' + this.template[0] + ' a Dezembro/' + this.template[1]

      //F00
      let periodo: any = []
      let nao_entregues = 0;
      for (let i: number = this.template[0]; i <= this.template[1]; i++) {
        periodo.push(i.toString());
      }
      for (let i = 11; i < 71; i++) {
        if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[1].getValue('A' + i, false)).split("/")[2])) {
          if (this.SS[1].getValue('B' + i, false) === '❌') {
            nao_entregues = nao_entregues + 1
          }
          if (this.SS[1].getValue('D' + i, false) === '❌') {
            nao_entregues = nao_entregues + 1
          }
        }
      }

      for (let i = 11; i < 71; i = i + 12) {
        if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[1].getValue('A' + i, false)).split("/")[2])) {
          if (this.SS[1].getValue('C' + i, false) === '❌') {
            nao_entregues = nao_entregues + 1
          }
        }
      }
      this.dashData[0].data[9][4] = nao_entregues

      //F02
      let tributos_pagos = [0, 0];
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('B10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('D10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('F10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('H10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('L10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('N10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('R10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('T10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('X10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('Z10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('AD10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[0] = tributos_pagos[0] + parseFloat(this.SS[3].getValue('AF10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));

      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('C10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('E10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('G10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('I10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('M10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('O10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('S10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('U10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('Y10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('AA10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('AE10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      tributos_pagos[1] = tributos_pagos[1] + parseFloat(this.SS[3].getValue('AG10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
      this.dashData[0].data[12][4] = tributos_pagos[0]
      this.dashData[0].data[13][4] = tributos_pagos[1]
      this.dashData[0].data[14][4] = tributos_pagos[0] + tributos_pagos[1]

      //F05
      let divergencias_pis = [0, 0]
      for (let i = 10; i < 70; i++) {
        if (parseFloat(this.SS[4].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_pis[0] = divergencias_pis[0] + parseFloat(this.SS[4].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[4].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_pis[1] = divergencias_pis[1] + (parseFloat(this.SS[4].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }

        if (parseFloat(this.SS[4].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_pis[0] = divergencias_pis[0] + parseFloat(this.SS[4].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[4].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_pis[1] = divergencias_pis[1] + (parseFloat(this.SS[4].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }
      }

      for (let i = 10; i < 70; i++) {
        if (parseFloat(this.SS[5].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_pis[0] = divergencias_pis[0] + parseFloat(this.SS[5].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[5].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_pis[1] = divergencias_pis[1] + (parseFloat(this.SS[5].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }

        if (parseFloat(this.SS[5].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_pis[0] = divergencias_pis[0] + parseFloat(this.SS[5].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[5].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_pis[1] = divergencias_pis[1] + (parseFloat(this.SS[5].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }
      }

      this.dashData[0].data[17][4] = divergencias_pis[0].two();
      this.dashData[0].data[18][4] = (divergencias_pis[1] * -1).two()

      //F04
      let divergencias_irpj = [0, 0]
      for (let i = 10; i < 30; i++) {
        if (parseFloat(this.SS[6].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_irpj[0] = divergencias_irpj[0] + parseFloat(this.SS[6].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[6].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_irpj[1] = divergencias_irpj[1] + (parseFloat(this.SS[6].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }

        if (parseFloat(this.SS[6].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_irpj[0] = divergencias_irpj[0] + parseFloat(this.SS[6].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[6].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_irpj[1] = divergencias_irpj[1] + (parseFloat(this.SS[6].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }
      }

      for (let i = 10; i < 30; i++) {
        if (parseFloat(this.SS[7].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_irpj[0] = divergencias_irpj[0] + parseFloat(this.SS[7].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[7].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_irpj[1] = divergencias_irpj[1] + (parseFloat(this.SS[7].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }

        if (parseFloat(this.SS[7].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_irpj[0] = divergencias_irpj[0] + parseFloat(this.SS[7].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[7].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_irpj[1] = divergencias_irpj[1] + (parseFloat(this.SS[7].getValue('I' + (i + 20), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }
      }

      for (let i = 10; i < 70; i++) {
        if (parseFloat(this.SS[8].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_irpj[0] = divergencias_irpj[0] + parseFloat(this.SS[8].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[8].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_irpj[1] = divergencias_irpj[1] + (parseFloat(this.SS[8].getValue('I' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }

        if (parseFloat(this.SS[8].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) > 0) {
          divergencias_irpj[0] = divergencias_irpj[0] + parseFloat(this.SS[8].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."))
        }
        if (parseFloat(this.SS[8].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) < 0) {
          divergencias_irpj[1] = divergencias_irpj[1] + (parseFloat(this.SS[8].getValue('S' + i, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) * -1)
        }
      }

      this.dashData[0].data[21][4] = divergencias_irpj[0].two();
      this.dashData[0].data[22][4] = (divergencias_irpj[1] * -1).two()

      //F05
      let apurado: any = [0, 0];
      apurado[0] = apurado[0] + parseFloat(this.SS[9].getValue('B10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      apurado[0] = apurado[0] + parseFloat(this.SS[9].getValue('C10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      apurado[0] = apurado[0] + parseFloat(this.SS[9].getValue('D10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      apurado[0] = apurado[0] + parseFloat(this.SS[9].getValue('E10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();

      apurado[1] = apurado[1] + parseFloat(this.SS[9].getValue('V10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      apurado[1] = apurado[1] + parseFloat(this.SS[9].getValue('W10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      apurado[1] = apurado[1] + parseFloat(this.SS[9].getValue('X10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      apurado[1] = apurado[1] + parseFloat(this.SS[9].getValue('Y10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();

      this.dashData[0].data[9][9] = ((apurado[0] * 0.65 / 100) + (apurado[1] * 3 / 100)).two()

      apurado = [0, 0];
      for (let i = 1; i < 12; i++) {
        if (this.SS[10].getValue(this.dashService.convertLetterToNumber(i) + '10', true) > 0) {
          let _tmp = 0;
          for (let u = 11; u < 71; u++) {
            _tmp = _tmp + parseFloat(this.SS[10].getValue(this.dashService.convertLetterToNumber(i) + u, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
          }
          apurado[0] = apurado[0] + (_tmp * this.SS[10].getValue(this.dashService.convertLetterToNumber(i) + '10', true) / 100).two()
        }
      }

      for (let i = 42; i < 53; i++) {
        if (this.SS[10].getValue(this.dashService.convertLetterToNumber(i) + '10', true) > 0) {
          let _tmp = 0;
          for (let u = 11; u < 71; u++) {
            _tmp = _tmp + parseFloat(this.SS[10].getValue(this.dashService.convertLetterToNumber(i) + u, true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));
          }
          apurado[1] = apurado[1] + (_tmp * this.SS[10].getValue(this.dashService.convertLetterToNumber(i) + '10', true) / 100).two()
        }
      }

      this.dashData[0].data[10][9] = (apurado[0] + apurado[1]).two()
      this.dashData[0].data[11][9] = parseFloat(this.SS[10].getValue('AC10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[11][9] = this.dashData[0].data[11][9] + parseFloat(this.SS[10].getValue('BR10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();

      this.dashData[0].data[12][9] = 0
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[9].getValue('H10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[9].getValue('I10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[9].getValue('AB10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[9].getValue('AC10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();

      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('O10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('P10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('Q10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('R10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('BD10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('BE10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('BF10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[12][9] = this.dashData[0].data[12][9] + parseFloat(this.SS[10].getValue('BG10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();

      //F06
      this.dashData[0].data[16][9] = parseFloat(this.SS[11].getValue('B69', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      if (this.dashData.findIndex(element => element.worksheetName === 'ECF - L300') > -1) {
        let keys: any = {};
        let tmp = this.dashData.find(element => element.worksheetName === 'ECF - L300');
        for (let u = 0; u < tmp.columns.length; u++) {
          if (tmp.columns[u].title === "ID_DT_INI") {
            keys['periodo'] = u;
          }
          if (tmp.columns[u].title === "PER_APUR") {
            keys['per'] = u;
          }
          if (tmp.columns[u].title === "CODIGO") {
            keys['cod'] = u;
          }
          if (tmp.columns[u].title === "VALOR") {
            keys['vl1'] = u;
          }
        }

        let l300 = {};
        const anos = this.dashService.getAnual()
        for (let i = 0; i < anos.length; i++) {
          l300[anos[i]] = [0];
        }

        for (let u = 0; u < tmp.data.length; u++) {
          let x = this.dashService.fromUS(tmp.data[u][keys['periodo']]).substr(-4);
          if (l300[x]) {
            if (tmp.data[u][keys['per']] === "A00") {
              if (tmp.data[u][keys['cod']] === "3.01.01.03") {
                l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
              }
              if (tmp.data[u][keys['cod']] === "3.01.01.07") {
                l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
              }
              if (tmp.data[u][keys['cod']] === "3.01.01.09") {
                l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
              }
            }

            if (
              tmp.data[u][keys['per']] === "T01" ||
              tmp.data[u][keys['per']] === "T02" ||
              tmp.data[u][keys['per']] === "T03" ||
              tmp.data[u][keys['per']] === "T04"
            ) {
              if (tmp.data[u][keys['cod']] === "3.01.01.03") {
                l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
              }
              if (tmp.data[u][keys['cod']] === "3.01.01.07") {
                l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
              }
              if (tmp.data[u][keys['cod']] === "3.01.01.09") {
                l300[x][0] = l300[x][0] + tmp.data[u][keys['vl1']].fix();
              }
            }
          }
        }

        this.dashData[0].data[15][9] = 0
        for (let i = 0; i < anos.length; i++) {
          this.dashData[0].data[15][9] = this.dashData[0].data[15][9] + (l300[anos[i]][0]).two()
        }
      } else {
        this.dashData[0].data[15][9] = 0
      }
      this.dashData[0].data[17][9] = this.dashData[0].data[15][9] - this.dashData[0].data[16][9]

      //F07
      this.dashData[0].data[20][9] = parseFloat(this.SS[12].getValue('B69', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[21][9] = parseFloat(this.SS[12].getValue('N69', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();
      this.dashData[0].data[22][9] = parseFloat(this.SS[12].getValue('O69', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).two();

      this.dashData[0].data[3][9] = this.donut(this.configuracoes.data.toString(), Number(await this.scoreCalc()))

      this.dashData[0].data[24][1] = this.configuracoes.footer;

      this.dashData[0].data[0][0] = 1;
      const res: any = await this.updateSheet(this.id, this.dashData[0].worksheetName, LZString.compressToBase64(JSON.stringify(this.dashData[0])));
      this.resetSheet(0);
    } catch (rejectedValue) {
      if (isDevMode()) {
        throw (rejectedValue);
      }
    }
    this.blockUI.stop()
  }

  async scoreCalc() {
    let pontos = [0, 0]

    let periodo: any = []
    for (let i: number = this.template[0]; i <= this.template[1]; i++) {
      periodo.push(i.toString());
    }

    let regimes = {}

    let tmp = this.dashData.findIndex(element => element.worksheetName === 'F01 - Inicial')
    for (let i = 3; i < 8; i++) {
      if (periodo.includes(this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + 33, false).toString())) {
        regimes[this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + 33, false).toString()] = [
          this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + 34, false),
          this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + 35, false)
        ]
      }
    }

    //F00
    for (let i = 11; i < 71; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[1].getValue('A' + i, false)).split("/")[2])) {
        if (this.SS[1].getValue('B' + i, false) === '❌') {
          pontos[1] = pontos[1] + 1;
        } else {
          pontos[0] = pontos[0] + 1;
        }
        if (this.SS[1].getValue('D' + i, false) === '❌') {
          pontos[1] = pontos[1] + 1;
        } else {
          pontos[0] = pontos[0] + 1;
        }
      }
    }

    for (let i = 11; i < 71; i = i + 12) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[1].getValue('A' + i, false)).split("/")[2])) {
        if (this.SS[1].getValue('C' + i, false) === '❌') {
          pontos[1] = pontos[1] + 1;
        } else {
          pontos[0] = pontos[0] + 1;
        }
      }
    }

    //F03A
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F03A - DCTF - PC CUMULATIVO')
    for (let i = 9; i < 69; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "CUMULATIVO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('Q' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('S' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F03B
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F03B - DCTF - PC NAO CUMULATIVO')
    for (let i = 9; i < 69; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "NÃO CUMULATIVO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('Q' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('S' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F04A
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F04A - DCTF - IRCS PRESUMIDO')
    for (let i = 9; i < 29; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "PRESUMIDO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }
    for (let i = 33; i < 53; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "PRESUMIDO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F04B
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F04B - DCTF - IRCS REAL TRIMEST')
    for (let i = 9; i < 29; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }
    for (let i = 33; i < 53; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F04C
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F04C - DCTF - IRCS REAL ANUAL')
    for (let i = 9; i < 69; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('Q' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('S' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F05A
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F05A - SPED CT - PC CUMULATIVO')
    for (let i = 9; i < 69; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "CUMULATIVO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('S' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('AM' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F05B
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F05B - SPED CT -  PC N CUMULAT')
    for (let i = 9; i < 69; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "NÃO CUMULATIVO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('AJ' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('BY' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F07
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F05B - SPED CT -  PC N CUMULAT')
    for (let i = 8; i < 68; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (parseFloat(parseFloat(this.SS[tmp].getValue('O' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
          pontos[0] = pontos[0] + 1;
        } else {
          pontos[1] = pontos[1] + 1;
        }
      }
    }

    //F08 NUMEROS INTEIROS
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F08 - ECF - IRPJ');
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F08 - ECF - IRPJ'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 9; i < 34; i++) {
      let per = ''
      if (this.SS[tmp].getValue('A' + (i + 1), false).length === 4) {
        per = this.SS[tmp].getValue('A' + (i + 1), false)
      } else {
        per = this.SS[tmp].getValue('A' + (i + 1), false).substr(-4)
      }
      if (periodo.includes(per)) {
        if (
          regimes[per][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('S' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }
    for (let i = 38; i < 58; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1), false).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1), false).substr(-4)][0] == "PRESUMIDO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('N' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F09 NUMEROS INTEIROS
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F09 - ECF - CSLL');
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F09 - ECF - CSLL'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 9; i < 34; i++) {
      let per = ''
      if (this.SS[tmp].getValue('A' + (i + 1), false).length === 4) {
        per = this.SS[tmp].getValue('A' + (i + 1), false)
      } else {
        per = this.SS[tmp].getValue('A' + (i + 1), false).substr(-4)
      }
      if (periodo.includes(per)) {
        if (
          regimes[per][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('S' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }
    for (let i = 38; i < 58; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1), false).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1), false).substr(-4)][0] == "PRESUMIDO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('J' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F10
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F10 - COMP FONTES PAGADORAS')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F10 - COMP FONTES PAGADORAS'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 1; i < 6; i++) {
      if (periodo.includes(this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + '10', false))) {
        if (parseFloat(parseFloat(this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + '15', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
          pontos[0] = pontos[0] + 1;
        } else {
          pontos[1] = pontos[1] + 1;
        }

        if (parseFloat(parseFloat(this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + '22', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
          pontos[0] = pontos[0] + 1;
        } else {
          pontos[1] = pontos[1] + 1;
        }

        if (parseFloat(parseFloat(this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + '29', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
          pontos[0] = pontos[0] + 1;
        } else {
          pontos[1] = pontos[1] + 1;
        }

        if (parseFloat(parseFloat(this.SS[tmp].getValue(this.dashService.convertLetterToNumber(i) + '36', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
          pontos[0] = pontos[0] + 1;
        } else {
          pontos[1] = pontos[1] + 1;
        }
      }
    }

    //F11
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F11 - COMPARATIVO DE RECEITAS')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F11 - COMPARATIVO DE RECEITAS'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 10; i < 15; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1), false))) {
        if (parseFloat(parseFloat(this.SS[tmp].getValue('F' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
          pontos[0] = pontos[0] + 1;
        } else {
          pontos[1] = pontos[1] + 1;
        }
      }
    }

    //F12A
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F12A - DARFxDCTFxSPED PC CUMULA')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F12A - DARFxDCTFxSPED PC CUMULA'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 9; i < 69; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "CUMULATIVO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('O' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F12B
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F12B - DARFxDCTFxSPED PC NAOCUM')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F12B - DARFxDCTFxSPED PC NAOCUM'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 9; i < 69; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "NÃO CUMULATIVO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('O' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F13A
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F13A - DARFxDCTFxECF IRCS PRESU')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F13A - DARFxDCTFxECF IRCS PRESU'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 9; i < 29; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "PRESUMIDO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('O' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F13B
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F13B - DARFxDCTFxECF IRCS R TRI')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F13B - DARFxDCTFxECF IRCS R TRI'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 9; i < 29; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('G' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('O' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F13C
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F13C - DARFxDCTFxECF IRCS RA')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F13C - DARFxDCTFxECF IRCS RA'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 8; i < 13; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1))][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('D' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }
    for (let i = 17; i < 23; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1))][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('D' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F14a
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F14a - APURAÇÕES DCTF X SPEDCT')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F14a - APURAÇÕES DCTF X SPEDCT'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 8; i < 68; i++) {
      if (periodo.includes(this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2])) {
        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "CUMULATIVO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('D' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }

        if (
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "NÃO CUMULATIVO" ||
          regimes[this.dashService.getJsDateFromExcel(this.SS[tmp].getValue('A' + (i + 1), false)).split("/")[2]][1] == "MISTO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('N' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('S' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    //F14b
    tmp = this.dashData.findIndex(element => element.worksheetName === 'F14b - APURAÇÕES DCTF X SPEDECF')
    if (tmp['data'] === undefined) {
      this.isMoving = true;
      await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'F14b - APURAÇÕES DCTF X SPEDECF'), 'Buscando dados...', 1);
      this.isMoving = false;
    }
    for (let i = 9; i < 29; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "PRESUMIDO"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('D' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }
    for (let i = 32; i < 52; i++) {
      if (periodo.includes(this.SS[tmp].getValue('A' + (i + 1)).substr(-4))) {
        if (
          regimes[this.SS[tmp].getValue('A' + (i + 1)).substr(-4)][0] == "REAL"
        ) {
          if (parseFloat(parseFloat(this.SS[tmp].getValue('D' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }

          if (parseFloat(parseFloat(this.SS[tmp].getValue('I' + (i + 1), true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")).toFixed()).two() === 0) {
            pontos[0] = pontos[0] + 1;
          } else {
            pontos[1] = pontos[1] + 1;
          }
        }
      }
    }

    return ((pontos[0] * 100) / (pontos[0] + pontos[1])).toFixed(0)
  }

  async PresuncaoCapa() {
    if (this.dashData.findIndex(element => element.worksheetName === 'ECF - P200') > -1) {
      if (this.dashData[this.dashData.findIndex(element => element.worksheetName === 'ECF - P200')]['data'] === undefined) {
        this.isMoving = true;
        await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'ECF - P200'), 'Buscando dados...', 1);
        this.isMoving = false;
      }
    }
    if (this.dashData.findIndex(element => element.worksheetName === 'ECF - P400') > -1) {
      if (this.dashData[this.dashData.findIndex(element => element.worksheetName === 'ECF - P400')]['data'] === undefined) {
        this.isMoving = true;
        await this.changeSheet(this.dashData.findIndex(element => element.worksheetName === 'ECF - P400'), 'Buscando dados...', 1);
        this.isMoving = false;
      }
    }

    this.blockUI.start('Calculando...');
    try {
      const template = this.dashData.find(element => element.worksheetName === 'F01 - Inicial');
      for (let i = 3; i <= 7; i++) {
        let presuncao1: Array<string> = [];
        let presuncao2: Array<string> = [];

        let keys: any = {};
        let tmp = this.dashData.find(element => element.worksheetName === 'ECF - P200');
        if (tmp !== undefined) {
          for (let u = 0; u < tmp.columns.length; u++) {
            if (tmp.columns[u].title === "ID_DT_INI") {
              keys['periodo'] = u;
            }
            if (tmp.columns[u].title === "CODIGO") {
              keys['cod'] = u;
            }
          }

          for (let u = 0; u < tmp.data.length; u++) {
            if (this.dashService.fromUS(tmp.data[u][keys['periodo']]).substr(-4) == template.data[32][i]) {
              if (tmp.data[u][keys['cod']] == 2) {
                if (!presuncao1.includes("1,6%")) {
                  presuncao1.push("1,6%")
                }
              }
              if (tmp.data[u][keys['cod']] == 4) {
                if (!presuncao1.includes("8%")) {
                  presuncao1.push("8%")
                }
              }
              if (tmp.data[u][keys['cod']] == 6) {
                if (!presuncao1.includes("16%")) {
                  presuncao1.push("16%")
                }
              }
              if (tmp.data[u][keys['cod']] == 8) {
                if (!presuncao1.includes("32%")) {
                  presuncao1.push("32%")
                }
              }
            }
          }
        }

        keys = {};
        tmp = this.dashData.find(element => element.worksheetName === 'ECF - P400');
        if (tmp !== undefined) {
          for (let u = 0; u < tmp.columns.length; u++) {
            if (tmp.columns[u].title === "ID_DT_INI") {
              keys['periodo'] = u;
            }
            if (tmp.columns[u].title === "CODIGO") {
              keys['cod'] = u;
            }
          }

          for (let u = 0; u < tmp.data.length; u++) {
            if (this.dashService.fromUS(tmp.data[u][keys['periodo']]).substr(-4) == template.data[32][i]) {
              if (tmp.data[u][keys['cod']] == 2) {
                if (!presuncao2.includes("12%")) {
                  presuncao2.push("12%")
                }
              }
              if (tmp.data[u][keys['cod']] == 4) {
                if (!presuncao2.includes("32%")) {
                  presuncao2.push("32%")
                }
              }
            }
          }
        }

        if (presuncao1.length === 0) {
          template.data[35][i] = 'NÃO APLICA'
        } else {
          template.data[35][i] = presuncao1.join("/");
        }

        if (presuncao2.length === 0) {
          template.data[36][i] = 'NÃO APLICA'
        } else {
          template.data[36][i] = presuncao2.join("/");
        }
      }

      this.dashData[2].data[1][1] = this.configuracoes.header;
      this.dashData[2].data[45][1] = this.configuracoes.footer;
      this.dashData[2].data[41][6] = 1
      const res: any = await this.updateSheet(this.id, this.dashData[2].worksheetName, LZString.compressToBase64(JSON.stringify(this.dashData[2])));
      this.resetSheet(2);
    } catch (rejectedValue) {
      throw (rejectedValue)
    }
    this.blockUI.stop()
  }

  resetSheet(index) {
    this.isMoving = true;
    this.SS[index].options.rows = {};
    this.SS[index].options.cells = {};
    this.SS[index].options.mergeCells = {};
    this.applyUpdates(index, this.dashData[index])
    this.isMoving = false;
  }

  applyUpdates(index, tmp) {
    if (tmp.columns.length < Object.keys(this.SS[index].options.columns).length) {
      this.SS[index].deleteColumn(tmp.columns.length - 1, Object.keys(this.SS[index].options.columns).length - tmp.columns.length)
    } else {
      if (tmp.columns.length > Object.keys(this.SS[index].options.columns).length) {
        this.SS[index].insertColumn(tmp.columns.length - Object.keys(this.SS[index].options.columns).length, null, false, [])
      }
    }

    for (let i = 0; i < tmp.columns.length; i++) {
      try {
        this.SS[index].setColumnOptions(i, tmp.columns[i])
      } catch (rejectedValue) {
      }
    }

    //Informações das Células
    if (tmp.cells) {
      Object.entries(tmp.cells).forEach((item) => {
        this.SS[index].setCells(item[0], item[1]);
      })
    }

    //Style?
    if (tmp.style) {
      this.SS[index].options.style = tmp.style;
    }

    //Dados
    this.SS[index].loadData(tmp.data)

    //Celulas mescladas
    if (tmp.mergeCells) {
      Object.entries(tmp.mergeCells).forEach((item) => {
        const sub: any = item[1]
        this.SS[index].setMerge(item[0], sub[0], sub[1]);
      })
    }

    if (tmp.rows) {
      Object.entries(tmp.rows).forEach((item: any) => {
        if (item[1] !== null) {
          if (item[1].height !== undefined) {
            this.SS[index].setHeight(item[0], item[1].height)
          }
          if (item[1].visible !== undefined) {
            if (this.SS[index].options.rows[item[0]] === undefined) {
              this.SS[index].options.rows[item[0]] = {}
            }

            if (item[1].visible === false) {
              this.SS[index].options.rows[item[0]]['visible'] = false;
              this.SS[index].hideRow(item[0])
            } else {
              this.SS[index].options.rows[item[0]]['visible'] = true;
              this.SS[index].showRow(item[0])
            }
          }
        }
      })
    }

    if (tmp.gridline === false) {
      this.SS[index].table.classList.add('jss_nogridline')
    } else {
      this.SS[index].table.classList.remove('jss_nogridline')
    }
    this.SS[index].options.gridline = tmp.gridline;

    if (tmp.freezeRows !== undefined) {
      try {
        this.SS[index].setFreezeRows(tmp.freezeRows), 500
      } catch {
      }
    }

    this.SS[index].options.filters = tmp.filters;
    if (tmp.filters) {
      this.SS[index].showFilter();
    } else {
      this.SS[index].closeFilter();
    }

    if (tmp.orderBy) {
      this.SS[index].orderBy(tmp.orderBy)
    }
  }

  async changeSheet(index: number, text: string, auto = 0) {
    if (this.dashData[index] !== undefined) {
      if (this.dashData[index]['data'] === undefined) {
        this.blockUI.start(text);
        try {
          const res: any = await this.fetchSheet(this.id, this.dashData[index]['worksheetName']);
          let tmp: any;
          if (res[0]['data'] !== '[]') {
            tmp = JSON.parse(LZString.decompressFromBase64(res[0]['data']));
          } else {
            tmp = [];
          }
          if (tmp['data'] === undefined) {
            const data = await this.calcular(this.dashData[index].worksheetName, text);

            this.dashData[index] = structuredClone(data);

            this.isMoving = true;

            this.applyUpdates(index, data);
            this.SS[index].content.scrollTop = 0
            this.SS[index].content.scrollLeft = 0

            this.isMoving = false;

            const res: any = await this.updateSheet(this.id, data.worksheetName, LZString.compressToBase64(JSON.stringify(this.dashData[index])));
          } else {
            this.dashData[index] = structuredClone(tmp);

            this.applyUpdates(index, tmp)

            this.SS[index].content.scrollTop = 0
            this.SS[index].content.scrollLeft = 0

            this.isMoving = false;
          }

          switch (this.dashData[index].worksheetName) {
            case "F00 - LOG":
              if (this.dashData[1].data[7][0] == 0) {
                for (let i = 10; i < 70; i++) {
                  this.dashData[1].data[i][0] = this.dashService.JSDateToExcelDate(this.dashData[1].data[i][0])
                }
                this.dashData[1].data[1][1] = this.configuracoes.header;
                this.dashData[1].data[71][1] = this.configuracoes.footer;
                this.dashData[1].data[7][0] = 1;
                const res: any = await this.updateSheet(this.id, this.dashData[1].worksheetName, LZString.compressToBase64(JSON.stringify(this.dashData[1])));
                this.resetSheet(1)
              }
              break;
            case "F01 - Inicial":
              if (this.dashData[2].data[41][6] == 0) {
                await this.PresuncaoCapa();
              }
              break;
            case "F05A - SPED CT - PC CUMULATIVO":
              if (auto === 0) {
                if (parseFloat(this.SS[index].getValue('S10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) >= 2) {
                  Swal.fire({
                    title: 'Atenção',
                    html: 'Há um problema com o Validador do PIS <h5 style="color:red">[R$ ' + parseFloat(this.SS[index].getValue('S10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) + ']</h5>',
                    icon: 'warning',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                }
                if (parseFloat(this.SS[index].getValue('AM10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) >= 2) {
                  Swal.fire({
                    title: 'Atenção',
                    html: 'Há um problema com o Validador do COFINS <h5 style="color:red">[R$ ' + parseFloat(this.SS[index].getValue('AM10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) + ']</h5>',
                    icon: 'warning',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                }
              }
              break;
            case "F05B - SPED CT -  PC N CUMULAT":
              if (auto === 0) {
                if (parseFloat(this.SS[index].getValue('AJ10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) >= 2) {
                  Swal.fire({
                    title: 'Atenção',
                    html: 'Há um problema com o Validador do PIS <h5 style="color:red">[R$ ' + parseFloat(this.SS[index].getValue('AJ10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) + ']</h5>',
                    icon: 'warning',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                }
                if (parseFloat(this.SS[index].getValue('BY10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) >= 2) {
                  Swal.fire({
                    title: 'Atenção',
                    html: 'Há um problema com o Validador do COFINS <h5 style="color:red">[R$ ' + parseFloat(this.SS[index].getValue('BY10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) + ']</h5>',
                    icon: 'warning',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                }
              }
              break;
            case "F08 - ECF - IRPJ":
              if (auto === 0) {
                Swal.fire({
                  title: 'Atenção',
                  html: '<p>Os seguintes campos são de preenchimento <span style="color:red">manual</span>:<p>Outros (IE. PERT)',
                  icon: 'warning',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                }).then(() => {
                  let vl1 =
                    parseFloat(this.SS[index].getValue('S10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S11', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S12', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S13', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S14', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S15', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S16', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S17', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S18', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S19', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S20', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S21', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S22', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S23', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S24', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S25', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S26', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S27', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S28', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S29', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S30', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));

                  if (vl1 < 0 && vl1 < -2) {
                    Swal.fire({
                      title: 'Atenção',
                      html: 'Há um problema com o Validador do IRPJ - LUCRO REAL <h5 style="color:red">[R$ ' + vl1.toFixed(2) + ']</h5>',
                      icon: 'warning',
                      heightAuto: false,
                      allowOutsideClick: false,
                      focusConfirm: false,
                      customClass: {
                        confirmButton: 'btn-swal'
                      },
                    });
                  }

                  if (vl1 > 0 && vl1 > 2) {
                    Swal.fire({
                      title: 'Atenção',
                      html: 'Há um problema com o Validador do IRPJ - LUCRO REAL <h5 style="color:red">[R$ ' + vl1.toFixed(2) + ']</h5>',
                      icon: 'warning',
                      heightAuto: false,
                      allowOutsideClick: false,
                      focusConfirm: false,
                      customClass: {
                        confirmButton: 'btn-swal'
                      },
                    });
                  }
                });
              }
              break;
            case "F09 - ECF - CSLL":
              if (auto === 0) {
                Swal.fire({
                  title: 'Atenção',
                  html: '<p>Os seguintes campos são de preenchimento <span style="color:red">manual</span>:<p>Outros (IE. PERT)',
                  icon: 'warning',
                  heightAuto: false,
                  allowOutsideClick: false,
                  focusConfirm: false,
                  customClass: {
                    confirmButton: 'btn-swal'
                  },
                }).then(() => {
                  let vl1 =
                    parseFloat(this.SS[index].getValue('S10', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S11', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S12', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S13', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S14', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S15', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S16', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S17', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S18', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S19', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S20', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S21', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S22', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S23', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S24', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S25', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S26', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S27', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S28', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S29', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", ".")) +
                    parseFloat(this.SS[index].getValue('S30', true).replaceAll(" R$	 ", "").replaceAll(".", "").replaceAll(",", "."));

                  if (vl1 < 0 && vl1 < -2) {
                    Swal.fire({
                      title: 'Atenção',
                      html: 'Há um problema com o Validador do CSLL - LUCRO REAL <h5 style="color:red">[R$ ' + vl1.toFixed(2) + ']</h5>',
                      icon: 'warning',
                      heightAuto: false,
                      allowOutsideClick: false,
                      focusConfirm: false,
                      customClass: {
                        confirmButton: 'btn-swal'
                      },
                    });
                  }

                  if (vl1 > 0 && vl1 > 2) {
                    Swal.fire({
                      title: 'Atenção',
                      html: 'Há um problema com o Validador do CSLL - LUCRO REAL <h5 style="color:red">[R$ ' + vl1.toFixed(2) + ']</h5>',
                      icon: 'warning',
                      heightAuto: false,
                      allowOutsideClick: false,
                      focusConfirm: false,
                      customClass: {
                        confirmButton: 'btn-swal'
                      },
                    });
                  }
                });
              }
              break;
            case "F10 - COMP FONTES PAGADORAS":
              if (auto === 0) {
                const codes = this.SS[index].getValue('A2', true).length === 0 ? [] : this.SS[index].getValue('A2', true).split("/");
                if (codes.length > 0) {
                  let text = "";
                  for (let codigo of codes) {
                    text = text + '<h5 style="color:red">' + codigo + '</h5>'
                  }
                  Swal.fire({
                    title: 'Atenção',
                    html: 'Os seguintes Códigos de Receita não foram encontrados: ' + text + 'Uma notificação foi enviada à equipe técnica para adição dos códigos.',
                    icon: 'warning',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                }
              }
              break;
          }
        } catch (rejectedValue) {
          if (isDevMode()) {
            throw (rejectedValue);
          }
        }
        this.blockUI.stop()
      }
    }
  }

  async ExportarXLSX() {
    Swal.fire({
      title: 'Selecione o Tipo de Exportação',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Apenas Fichas',
      denyButtonText: 'Completa',
      icon: 'warning',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel',
        denyButton: 'btn-swal-deny'
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        for (let [index, current] of this.dashData.entries()) {
          if (current['data'] === undefined) {
            if (this.noPrint.includes(current.worksheetName)) {
              this.isMoving = true;
              await this.changeSheet(index, 'Gerando Excel...', 1);
              this.isMoving = false;
            }
          }
        }

        this.blockUI.start('Gerando Excel...');
        const tmp = this.dashData.find(element => element.worksheetName === "F01 - Inicial");
        const name = tmp.data[13][3] + ' - ' + tmp.data[12][3] + '.xlsx';
        await jspreadsheet.render(this.spreadsheet.nativeElement, {
          filename: name,
          type: 0
        });
        this.blockUI.stop()
      } else if (result.isDenied) {
        for (let [index, current] of this.dashData.entries()) {
          if (current['data'] === undefined) {
            this.isMoving = true;
            await this.changeSheet(index, 'Gerando Excel...', 1);
            this.isMoving = false;
          }
        }

        this.blockUI.start('Gerando Excel...');
        const tmp = this.dashData.find(element => element.worksheetName === "F01 - Inicial");
        const name = tmp.data[13][3] + ' - ' + tmp.data[12][3] + '.xlsx';
        await jspreadsheet.render(this.spreadsheet.nativeElement, {
          filename: name,
          type: 1
        });
        this.blockUI.stop()
      }
    })
  }

  async Recalcular() {
    Swal.fire({
      title: 'Recalcular?',
      text: "Este processo é irreversível!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Recalcular',
      cancelButtonText: 'Cancelar',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel'
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        const sheets = this.dashService.getSheetNames();
        for (let current of sheets.reverse()) {
          const result = this.dashData.findIndex(element => element.worksheetName === current);
          if (this.dashData[result] !== undefined) {
            if (this.dashData[result]['data'] === undefined) {
              this.isMoving = true;
              await this.changeSheet(result, 'Buscando dados...', 1);
              this.isMoving = false;
            }
          }
        }

        if (this.dashData[1]['data'] === undefined) {
          this.isMoving = true;
          await this.changeSheet(1, 'Buscando dados...', 1);
          this.isMoving = false;
        }
        if (this.dashData[2]['data'] === undefined) {
          this.isMoving = true;
          await this.changeSheet(2, 'Buscando dados...', 1);
          this.isMoving = false;
        }

        this.blockUI.start('Recalculando...');
        try {
          for (let current of sheets) {
            const result = this.dashData.findIndex(element => element.worksheetName === current);
            if (this.dashData[result] !== undefined) {
              const data = await this.calcular(current, 'Recalculando...');
              this.dashData[result] = structuredClone(data);
              const res: any = await this.updateSheet(this.id, data.worksheetName, LZString.compressToBase64(JSON.stringify(this.dashData[result])));
              this.resetSheet(result);
            }
          }
          await this.PresuncaoCapa();
          await this.scoreCard();
        } catch (rejectedValue) {
          if (isDevMode()) {
            throw (rejectedValue);
          }
        }
        this.blockUI.stop()
        this.SS[0].openWorksheet(0);
      }
    })
  }

  async calcular(name: string, text: string) {
    const template: any = await this.dashService.getTemplate(name);
    if (template) {
      if (this.configuracoes === null) {
        this.configuracoes = await this.fetchConfiguracoes();
      }
      for (let current of template['require']) {
        const result = this.dashData.findIndex(element => element.worksheetName === current);
        if (this.dashData[result] !== undefined) {
          if (this.dashData[result]['data'] === undefined) {
            this.isMoving = true;
            await this.changeSheet(result, text, 1);
          }
        }
      }
      switch (name) {
        case "F02 - DARFs":
          return this.dashService.F02(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F03A - DCTF - PC CUMULATIVO":
          return this.dashService.F03A(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F03B - DCTF - PC NAO CUMULATIVO":
          return this.dashService.F03B(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F04A - DCTF - IRCS PRESUMIDO":
          return this.dashService.F04A(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F04B - DCTF - IRCS REAL TRIMEST":
          return this.dashService.F04B(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F04C - DCTF - IRCS REAL ANUAL":
          return this.dashService.F04C(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F05A - SPED CT - PC CUMULATIVO":
          return this.dashService.F05A(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F05B - SPED CT -  PC N CUMULAT":
          return this.dashService.F05B(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F06 - SPED CT - INSUMOS":
          return this.dashService.F06(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F07 - SPED CT - CST":
          return this.dashService.F07(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F08 - ECF - IRPJ":
          return this.dashService.F08(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F09 - ECF - CSLL":
          return this.dashService.F09(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F10 - COMP FONTES PAGADORAS":
          return this.dashService.F10(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F11 - COMPARATIVO DE RECEITAS":
          return this.dashService.F11(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F12A - DARFxDCTFxSPED PC CUMULA":
          return this.dashService.F12A(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F12B - DARFxDCTFxSPED PC NAOCUM":
          return this.dashService.F12B(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F13A - DARFxDCTFxECF IRCS PRESU":
          return this.dashService.F13A(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F13B - DARFxDCTFxECF IRCS R TRI":
          return this.dashService.F13B(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F13C - DARFxDCTFxECF IRCS RA":
          return this.dashService.F13C(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F14a - APURAÇÕES DCTF X SPEDCT":
          return this.dashService.F14A(structuredClone(template.data), this.dashData, this.configuracoes);
        case "F14b - APURAÇÕES DCTF X SPEDECF":
          return this.dashService.F14B(structuredClone(template.data), this.dashData, this.configuracoes);
      }
    }
  }

  fetchConfiguracoes() {
    return new Promise((resolve, reject) => {
      this.userService.fetchConfiguracoes().subscribe(
        (res: any) => {
          resolve(res);
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.blockUI.stop()
          reject()
        }
      )
    });
  }

  updateSheet(id: number, name: string, data: any) {
    return new Promise((resolve, reject) => {
      this.userService.updateSheet(id, name, data).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.blockUI.stop()
          reject()
        }
      )
    });
  }

  async myChange(worksheet: jspreadsheet.worksheetInstance) {
    if (this.isMoving) {
      return
    }

    let obj = {
      "worksheetName": worksheet.options.worksheetName,
      "filters": worksheet.options.filters,
      "data": worksheet.options.data,
      "columns": worksheet.options.columns,
      "style": worksheet.options.style,
      "cells": worksheet.options.cells,
      "rows": worksheet.options.rows,
      "mergeCells": worksheet.options.mergeCells,
      "orderBy": worksheet.options.orderBy,
      "gridline": worksheet.options.gridline,
      "freezeRows": worksheet.options.freezeRows
    }

    if (isDevMode()) {
      console.log(obj)
    }
    const res: any = await this.updateSheet(this.id, obj.worksheetName as string, LZString.compressToBase64(JSON.stringify(obj)));
    this.dashData[this.dashData.findIndex(element => element.worksheetName === obj.worksheetName as string)] = JSON.parse(JSON.stringify(obj));
  }

  initXLSX() {
    jspreadsheet.setLicense(
      "MDkyZWRjMThhM2I5ZTk5Yzc5NDBiY2ZhMzJjYTMxOTU2MmU3Mjk2NGUyNmNjMTM4NmJmMDRkNWM0YTA2YmFhMzc3ODhkOGM5MzU0NWFkYzdhNTUwOWNmZDc5NGU4NzQ5NDM3MGEwMGU2NjU2NmJkYzY1Yjg1YWQzNzQ5MGEwNTUsZXlKdVlXMWxJam9pUm1Wc2FYQmxJaXdpWkdGMFpTSTZNVFkyT1RjMk5qUXdNQ3dpWkc5dFlXbHVJanBiSWpFeU55NHdMakF1TVNJc0lteHZZMkZzYUc5emRDSmRMQ0p3YkdGdUlqb3dMQ0p6WTI5d1pTSTZXeUoyTnlJc0luWTRJaXdpZGpraVhYMD0="
    );

    jspreadsheet.setExtensions({ render });

    jspreadsheet.setDictionary({
      'Show': 'Mostrar',
      'Search': 'Buscar',
      'entries': ' entradas',
      'Column name': 'Nome da coluna',
      'Change column type': 'Mudar tipo de coluna',
      'Insert a new column before': 'Inserir uma coluna antes',
      'Insert a new column after': 'Inserior uma coluna depois',
      'Delete selected columns': 'Apagar colunas selecionadas',
      'Rename this column': 'Renonear essa coluna',
      'Order ascending': 'Ordenar ascendente',
      'Order descending': 'Ordenar descendente',
      'Insert a new row before': 'Inserir uma nova linha antes',
      'Insert a new row after': 'Inserir uma nova linha depois',
      'Delete selected rows': 'Apagar linhas selecionadas',
      'Edit comments': 'Editar comentários',
      'Add comments': 'Adicionar comentários',
      'Comments': 'Comentários',
      'Clear comments': 'Apagar comentários',
      'Copy': 'Copiar',
      'Paste': 'Colar',
      'Save as': 'Salvar como',
      'About': 'Sobre',
      'Are you sure?': 'Tenha certeza:',
      'This action will destroy any existing merged cells. Are you sure?':
        'Essa ação irá desturir as celulas mescladas existentes. Tem certeza?',
      'Invalid merged properties': 'Propriedades de mesclagem inválidas',
      'No cell selected': 'Nenhuma celula selecionada',
      'Rename this worksheet': 'Renomear essa planilha',
      'Delete this worksheet': 'Apagar essa planilha',
      'It was not possible to rename worksheet due conflict name':
        'Não foi possível renomear essa planilha devido a um conflito de nomes',
      'Cut': 'Cortar',
      'Hide': 'Esconder',
      'Unhide': 'Mostrar',
      'Select All': 'Selecionar tudo',
      'Blanks': 'Brancos',
      'Add current selection to filter': 'Adicionar seleção atual ao filtro',
      'Rename this cell': 'Renomear celula',
      'January': 'Janeiro',
      'February': 'Fevereiro',
      'March': 'Março',
      'April': 'Abril',
      'May': 'Maio',
      'June': 'Junho',
      'July': 'Julho',
      'August': 'Agosto',
      'September': 'Setembro',
      'October': 'Outubro',
      'November': 'Novembro',
      'December': 'Dezembro',
      'Sunday': 'Domingo',
      'Monday': 'Segunda',
      'Tuesday': 'Terca',
      'Wednesday': 'Quarta',
      'Thursday': 'Quinta',
      'Friday': 'Sexta',
      'Saturday': 'Sabado',
      'Done': 'Feito',
      'Reset': 'Apagar',
      'Update': 'Atualizar',
    });

    this.SS = jspreadsheet(this.spreadsheet.nativeElement, {
      tabs: true,
      fullscreen: true,
      autoCasting: false,
      allowExport: false,
      allowDeleteWorksheet: false,
      allowRenameWorksheet: false,
      allowMoveWorksheet: false,
      toolbar: (toolbar) => {
        console.log('aaa')
        //if (!isDevMode()) {
          toolbar.items = [];

          toolbar.items.push({
            content: 'undo',
            onclick: function () {
              if (jspreadsheet.current) {
                jspreadsheet.current.undo();
              }
            }
          });

          toolbar.items.push({
            content: 'redo',
            onclick: function () {
              if (jspreadsheet.current) {
                jspreadsheet.current.redo();
              }
            }
          });

          toolbar.items.push({
            type: 'divisor',
          });

          toolbar.items.push({
            type: 'i',
            content: 'format_bold',
            k: 'font-weight',
            v: 'bold'
          });

          toolbar.items.push({
            type: 'color',
            content: 'format_color_text',
            k: 'color'
          });

          toolbar.items.push({
            type: 'color',
            content: 'format_color_fill',
            k: 'background-color'
          });

          toolbar.items.push({
            type: 'divisor',
          });

          toolbar.items.push({
            type: 'label',
            tooltip: 'Recalcular as informações das fichas',
            content: '<i style="display: inline-block; vertical-align: middle;" class="material-icons">calculate</i><span style="vertical-align: middle;">Recalcular</span>',
            onclick: async () => {
              await this.Recalcular()
            }
          });
          toolbar.items.push({
            type: 'label',
            tooltip: 'Baixar as fichas para Excel',
            content: '<i style="display: inline-block; vertical-align: middle;" class="material-icons">file_download</i><span style="vertical-align: middle;">Exportar</span>',
            onclick: async () => {
              await this.ExportarXLSX()
            }
          });
        //}
        return toolbar;
      },
      contextMenu: function (obj, x, y, e, items, section) {
        //if (!isDevMode()) {
          items = [];

          if (section as unknown == 'header' || section as unknown == 'row' || section as unknown == 'cell' || section as unknown == 'nested') {
            items.push({
              title: 'Recortar',
              icon: 'content_cut',
              shortcut: 'Ctrl + X',
              onclick: function () {
                obj.cut();
              }
            });

            items.push({
              title: 'Copiar',
              icon: 'content_copy',
              shortcut: 'Ctrl + C',
              onclick: function () {
                obj.copy();
              }
            });

            if (navigator && navigator.clipboard && navigator.clipboard.readText) {
              items.push({
                title: 'Colar',
                icon: 'content_paste',
                shortcut: 'Ctrl + V',
                onclick: function () {
                  if (obj.selectedCell) {
                    navigator.clipboard.readText().then(function (text) {
                      if (text) {
                        obj.paste(obj.selectedCell[0], obj.selectedCell[1], text);
                      }
                    });
                  }
                }
              });
            }
          }
        //}
        return items;
      },
      plugins: [
        {
          name: 'statusBar', plugin: jss_statusbar, options: {
            showAddRowButton: false,
            formulas: {
              "Seleção": "{range}",
              "Média": "=IFERROR(AVERAGE({range}),0)",
              "Contagem": "=COUNT({range})",
              "Soma": "=SUM({range})",
            }
          }
        },
        { name: 'formula', plugin: jss_formula },
      ],
      wordWrap: true,
      worksheets: this.dashData,
      parseFormulas: true,
      onopenworksheet: async (worksheet: jspreadsheet.worksheetInstance, index: number) => {
        if (this.dashData[index].data === undefined) {
          this.isMoving = true;
        }
        this.changeSheet(index, 'Buscando dados...')
      },
      onafterchanges: async (worksheet: jspreadsheet.worksheetInstance, records: any[]) => {
        await this.myChange(worksheet)
      },
      onchangestyle: async (worksheet: any, newValue: Object, oldValue: Object) => {
        await this.myChange(worksheet)
      },

      oninsertrow: async (worksheet: jspreadsheet.worksheetInstance, rowNumber: number, numOfRows: number, rowData: [], insertBefore: boolean) => {
        await this.myChange(worksheet)
      },
      ondeleterow: async (worksheet: jspreadsheet.worksheetInstance, rowNumber: number, numOfRows: number, rowHTMLElements: [], rowData: [], cellAttributes: []) => {
        await this.myChange(worksheet)
      },
      oninsertcolumn: async (worksheet: jspreadsheet.worksheetInstance, columnNumber: number, numOfColumns: number, historyRecords: [], insertBefore: boolean) => {
        await this.myChange(worksheet)
      },
      ondeletecolumn: async (worksheet: jspreadsheet.worksheetInstance, columnNumber: number, numOfColumns: number, affectedHTMLElements: [], historyProperties: [], cellAttributes: []) => {
        await this.myChange(worksheet)
      },
      onresizerow: async (worksheet: jspreadsheet.worksheetInstance, row: number | number[], height: number | number[], oldHeight: number | number[]) => {
        await this.myChange(worksheet)
      },
      onresizecolumn: async (worksheet: jspreadsheet.worksheetInstance, column: number | number[], width: number | number[], oldWidth: number | number[]) => {
        await this.myChange(worksheet)
      },
      oncomments: async (worksheet: jspreadsheet.worksheetInstance, newValues: object, previousValues: object) => {
        await this.myChange(worksheet)
      },
      onsort: async (worksheet: jspreadsheet.worksheetInstance, column: number, direction: number, newOrderValues: []) => {
        await this.myChange(worksheet)
      },
      onmerge: async (worksheet: jspreadsheet.worksheetInstance, newValue: object, oldValue: object) => {
        await this.myChange(worksheet)
      }
    })

    document.getElementsByClassName('jtabs-headers')[0].scrollLeft = 0;
    this.SS[0].openWorksheet(0)
  }

  fetchSheet(id: number, sheet: string) {
    return new Promise((resolve, reject) => {
      this.userService.getSheet({ id, sheet }).subscribe(
        (res: any) => {
          resolve(res);
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              }).then(() => {
                this.router.navigate(['/analises']);
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.blockUI.stop()
          reject()
        }
      )
    });
  }
}

